/**
=========================================================
* Argon Dashboard 2 PRO MUI - v3.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-mui
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Switch from "@mui/material/Switch";
import { useState } from "react";

// Argon Dashboard 2 PRO MUI components
import { useNavigate } from "react-router-dom";

import { useSession } from "0.Mine/2.Context/sessionContext";
import burceMars from "assets/images/bruce-mars.jpg";
import ArgonAvatar from "components/ArgonAvatar";

// Images

import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";

function Header() {
  const [visible, setVisible] = useState(true);
  const { session } = useSession();
  const handleSetVisible = () => setVisible(!visible);
  const navigate = useNavigate();

  if (!session) {
    navigate("/signin");
  }

  return (
    <Card id="profile">
      <ArgonBox p={2}>
        <Grid container spacing={3} alignItems="center">
          <Grid item>
            <ArgonAvatar
              src={session.user.image}
              alt="profile-image"
              variant="rounded"
              size="xl"
              shadow="sm"
            />
          </Grid>
          <Grid item>
            <ArgonBox height="100%" mt={0.5} lineHeight={1}>
              <ArgonTypography variant="h5" fontWeight="medium">
                {session.user.name}
              </ArgonTypography>
              <ArgonTypography variant="button" color="text" fontWeight="medium">
                {session.user.email}
              </ArgonTypography>
            </ArgonBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3} sx={{ ml: "auto" }}>
            <ArgonBox
              display="flex"
              justifyContent={{ md: "flex-end" }}
              alignItems="center"
              lineHeight={1}
            >
              <ArgonBox mx={1}></ArgonBox>
            </ArgonBox>
          </Grid>
        </Grid>
      </ArgonBox>
    </Card>
  );
}

export default Header;
